import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillDelete } from "react-icons/ai"; // Added AiFillDelete
import { apiPut, apiDelete } from "../../../utils/apiFetch"; // Added apiDelete
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import apiPath from "../../../utils/apiPath";
import { useContext } from "react";
import { isEmpty } from "lodash";
import helper from "../../../utils/helpers";
import AuthContext from "context/AuthContext";
import { BsArrowUpShort } from "react-icons/bs";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const CategoryList = ({
  handleEdit,
  sort,
  setSort,
  categoryList,
  page,
  allCategory,
  manager,
}) => {
  const notification = useToastContext();
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  const handelStatusChangeItem = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.adminCategoryStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allCategory({ statusChange: 1 });
      }
    } catch (error) {
      console.log("error in get all category list==>>>>", error.message);
    }
  };

  // Added Delete Function
  const handleDeleteItem = async (item) => {
    try {
      const path = `${apiPath.adminCategory}/${item?._id}`; // Assumes your base path is adminCategory
      const result = await apiDelete(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allCategory({ deletePage: 1 });
      }
    } catch (error) {
      notification.error(error?.response?.data?.message || "Error deleting category");
    }
  };

  const confirmDelete = (item) => {
    helper.alertFunction(
      `Are you sure you want to delete '${item.name}'?`,
      item,
      handleDeleteItem
    );
  };

  return (
    <div>
      <div className="p-3">
        <div className="rounded-lg relative overflow-x-auto border">
          <table className="text-[#6c6c6c] w-full text-xs dark:text-gray-400 text-left ">
            <thead className="border-[#E1E6EE] text-xs text-gray-900 border bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <TableHeaderCell text={t("SR_NO")} />
                <TableHeaderCell text={t("CATEGORY_NAME")} />
                {/* ... (Keep Created, Updated, Status headers as is) ... */}
                <th
                  onClick={() => {
                    const newSortType =
                      sort.sortType === "asc" ? "desc" : "asc";
                    setSort({
                      sortBy: "createdAt",
                      sortType: newSortType,
                    });
                  }}
                  scope="col"
                  className="cursor-pointer py-3 px-6 "
                >
                  <div className="flex justify-start">
                    <span>{t("CREATED_DATE")}</span>
                    <span>
                      {sort.sortBy === "createdAt" && (
                        <BsArrowUpShort
                          className={`w-4 h-4 ${sort.sortType === "asc" ? "" : "rotate-180"}`}
                        />
                      )}
                    </span>
                  </div>
                </th>
                <th
                  className="py-3 cursor-pointer px-6"
                  scope="col"
                  onClick={() => {
                    if (
                      sort.sortType === "asc" &&
                      sort.sortBy === "updatedAt"
                    ) {
                      setSort({
                        sortBy: "updatedAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortType: "asc",
                        sortBy: "updatedAt",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("UPDATED_DATE")}</span>
                    <span>
                      {sort.sortBy === "updatedAt" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="h-4 w-4 " />
                        )}
                      {sort.sortBy === "updatedAt" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>

                <th scope="col" className="text-center py-3 px-6 ">
                  {t("O_STATUS")}
                </th>
                {(manager?.edit || user?.role === "admin") && (
                  <th className="py-3 px-6 text-center" scope="col">
                    {t("O_ACTION")}
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {categoryList &&
                categoryList.map((item, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white dark:border-gray-700 border-b dark:bg-gray-800 "
                    >
                      <th
                        scope="row"
                        className="font-medium text-gray-900 py-4 px-6 border-r dark:text-white"
                      >
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="py-4 border-r px-6 text-gray-900">
                        {item?.name}
                      </td>
                      <td className="text-gray-900 py-4 px-6 border-r">
                        {dayjs(item?.createdAt).format(
                          "MM-DD-YYYY h:mm A",
                        )}{" "}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {dayjs(item?.updatedAt).format(
                          "MM-DD-YYYY h:mm A",
                        )}{" "}
                      </td>

                      <td className="py-4 px-6 border-r text-center text-gray-900">
                        <label
                          className="items-center cursor-pointer inline-flex relative "
                          title={`${item?.status === "active" ? "Active" : "Inactive"}`}
                        >
                          <input
                            type="checkbox"
                            onChange={(e) =>
                              helper.alertFunction(
                                `Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}' ?`,
                                item,
                                handelStatusChangeItem,
                              )
                            }
                            checked={item?.status === "active"}
                            className="peer sr-only "
                          />
                          <div className="peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer peer-focus:ring-0 w-10 h-5 bg-gray-200 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                        </label>
                      </td>
                      {(manager?.edit || user?.role === "admin") && (
                        <td className="border-l py-4 px-6 text-gray-900">
                          <div className="">
                            <ul className="flex justify-center gap-3">
                              <li
                                onClick={() => handleEdit(item)}
                                className="hover:text-LightBlue px-2 py-2 hover:bg-white"
                              >
                                <a
                                  className="hover:text-blue-700 transition duration-150 ease-in-out"
                                  data-bs-toggle="tooltip"
                                  title={t("EDIT_CATEGORY")}
                                >
                                  {" "}
                                  <AiFillEdit className="cursor-pointer text-slate-600 w-5 h-5 " />
                                </a>
                              </li>
                              {/* Added Delete Button */}
                              <li
                                onClick={() => confirmDelete(item)}
                                className="hover:text-red-500 px-2 py-2 hover:bg-white"
                              >
                                <a
                                  className="hover:text-red-700 transition duration-150 ease-in-out"
                                  data-bs-toggle="tooltip"
                                  title="Delete Category"
                                >
                                  <AiFillDelete className="cursor-pointer text-red-500 w-5 h-5" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              {isEmpty(categoryList) ? (
                <tr className="bg-white dark:bg-gray-800 border-b text-center  dark:border-gray-700">
                  <td colSpan={6} className="py-4 px-6 border-r">
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CategoryList;




// import useToastContext from "hooks/useToastContext";
// import { AiFillEdit } from "react-icons/ai";
// import { apiPut } from "../../../utils/apiFetch";
// import { useTranslation } from "react-i18next";
// import dayjs from "dayjs";
// import apiPath from "../../../utils/apiPath";
// import { useContext } from "react";
// import { isEmpty } from "lodash";
// import helper from "../../../utils/helpers";
// import AuthContext from "context/AuthContext";
// import { BsArrowUpShort } from "react-icons/bs";
// import TableHeaderCell from "components/reusable/TableHeaderCell";

// const CategoryList = ({
//   handleEdit,
//   sort,
//   setSort,
//   categoryList,
//   page,
//   allCategory,
//   manager,
// }) => {
//   const notification = useToastContext();
//   const { t } = useTranslation();
//   const { user } = useContext(AuthContext);

//   const handelStatusChangeItem = async (item) => {
//     try {
//       const payload = {
//         status: item?.status === "inactive" ? "active" : "inactive",
//       };
//       const path = `${apiPath.adminCategoryStatus}/${item?._id}`;
//       const result = await apiPut(path, payload);
//       if (result?.status === 200) {
//         notification.success(result.data.message);
//         allCategory({ statusChange: 1 });
//       }
//     } catch (error) {
//       console.log("error in get all category list==>>>>", error.message);
//     }
//   };

//   return (
//     <div>
//       <div className="p-3">
//         <div className="rounded-lg relative overflow-x-auto border">
//           <table className="text-[#6c6c6c] w-full text-xs dark:text-gray-400 text-left ">
//             <thead className="border-[#E1E6EE] text-xs text-gray-900 border bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
//               <tr>
//                 <TableHeaderCell text={t("SR_NO")} />
//                 <TableHeaderCell text={t("CATEGORY_NAME")} />
//                 <th
//                   onClick={() => {
//                     const newSortType =
//                       sort.sortType === "asc" ? "desc" : "asc";
//                     setSort({
//                       sortBy: "createdAt",
//                       sortType: newSortType,
//                     });
//                   }}
//                   scope="col"
//                   className="cursor-pointer py-3 px-6 "
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("CREATED_DATE")}</span>
//                     <span>
//                       {sort.sortBy === "createdAt" && (
//                         <BsArrowUpShort
//                           className={`w-4 h-4 ${sort.sortType === "asc" ? "" : "rotate-180"}`}
//                         />
//                       )}
//                     </span>
//                   </div>
//                 </th>
//                 <th
//                   className="py-3 cursor-pointer px-6"
//                   scope="col"
//                   onClick={() => {
//                     if (
//                       sort.sortType === "asc" &&
//                       sort.sortBy === "updatedAt"
//                     ) {
//                       setSort({
//                         sortBy: "updatedAt",
//                         sortType: "desc",
//                       });
//                     } else {
//                       setSort({
//                         sortType: "asc",
//                         sortBy: "updatedAt",
//                       });
//                     }
//                   }}
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("UPDATED_DATE")}</span>
//                     <span>
//                       {sort.sortBy === "updatedAt" &&
//                         sort.sortType === "asc" && (
//                           <BsArrowUpShort className="h-4 w-4 " />
//                         )}
//                       {sort.sortBy === "updatedAt" &&
//                         sort.sortType === "desc" && (
//                           <BsArrowUpShort className="w-4 h-4 rotate-180" />
//                         )}
//                     </span>
//                   </div>
//                 </th>

//                 <th scope="col" className="text-center py-3 px-6 ">
//                   {t("O_STATUS")}
//                 </th>
//                 {(manager?.edit || user?.role === "admin") && (
//                   <th className="py-3 px-6 text-center" scope="col">
//                     {t("O_ACTION")}
//                   </th>
//                 )}
//               </tr>
//             </thead>

//             <tbody>
//               {categoryList &&
//                 categoryList.map((item, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white dark:border-gray-700 border-b dark:bg-gray-800 "
//                     >
//                       <th
//                         scope="row"
//                         className="font-medium text-gray-900 py-4 px-6 border-r dark:text-white"
//                       >
//                         {i + 1 + 10 * (page - 1)}
//                       </th>
//                       <td className="py-4 border-r px-6 text-gray-900">
//                         {item?.name}
//                       </td>
//                       <td className="text-gray-900 py-4 px-6 border-r">
//                         {dayjs(item?.createdAt).format(
//                           "MM-DD-YYYY h:mm A",
//                         )}{" "}
//                       </td>
//                       <td className="py-4 px-6 border-r text-gray-900">
//                         {dayjs(item?.updatedAt).format(
//                           "MM-DD-YYYY h:mm A",
//                         )}{" "}
//                       </td>

//                       <td className="py-4 px-6 border-r text-center text-gray-900">
//                         <label
//                           className="items-center cursor-pointer inline-flex relative "
//                           title={`${item?.status === "active" ? "Active" : "Inactive"}`}
//                         >
//                           <input
//                             type="checkbox"
//                             onChange={(e) =>
//                               helper.alertFunction(
//                                 `Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}' ?`,
//                                 item,
//                                 handelStatusChangeItem,
//                               )
//                             }
//                             checked={item?.status === "active"}
//                             className="peer sr-only "
//                           />
//                           <div className="peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer peer-focus:ring-0 w-10 h-5 bg-gray-200 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
//                         </label>
//                       </td>
//                       {(manager?.edit || user?.role === "admin") && (
//                         <td className="border-l py-4 px-6 text-gray-900">
//                           <div className="">
//                             <ul className="flex justify-center">
//                               <li
//                                 onClick={() => handleEdit(item)}
//                                 className="hover:text-LightBlue px-2 py-2 hover:bg-white"
//                               >
//                                 <a
//                                   className="hover:text-blue-700 transition duration-150 ease-in-out"
//                                   data-bs-toggle="tooltip"
//                                   title={t("EDIT_CATEGORY")}
//                                 >
//                                   {" "}
//                                   <AiFillEdit className="cursor-pointer text-slate-600 w-5 h-5 " />
//                                 </a>
//                               </li>
//                             </ul>
//                           </div>
//                         </td>
//                       )}
//                     </tr>
//                   );
//                 })}
//               {isEmpty(categoryList) ? (
//                 <tr className="bg-white dark:bg-gray-800 border-b text-center  dark:border-gray-700">
//                   <td colSpan={6} className="py-4 px-6 border-r">
//                     {t("O_NO_RECORD_FOUND")}
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CategoryList;
